import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ParamsModel} from 'src/app/modules/common/Model'

function* getSubscribeSaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload
    yield delay(500)
    const response: ResponseModel = yield call(service.getSubscribe, params)
    yield put(actions.getSubscribeSuccess(response?.data?.data))
    yield delay(100)
    yield put(actions.getSubscribeFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getSubscribeFinish())
  }
}

function* deleteSubscribeSaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.deleteSubscribe, body)
    yield put(actions.deleteSubscribeSuccess(response.data?.data))
    yield delay(0.1)
    yield put(actions.deleteSubscribeFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.deleteSubscribeFinish())
  }
}

//Get branchless file
function* exportSubscribeFileSaga(action: ActionModel) {
  try {
    const fileName: any = action.payload.fileName
    const params: any = action.payload.params
    const response: ResponseModel = yield call(service.exportSubscribeFile, fileName, params)
    const responseData: any = response?.data
    yield put(actions.exportFileSuccess(responseData))
    yield put(actions.exportFileError())
  } catch (error: any) {
    if (error.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: error.response.data.message})
    }
    yield put(actions.exportFileError())
  }
}

export function* saga() {
  yield takeLatest(actionTypes.DELETE_SUBSCRIBE_START, deleteSubscribeSaga)
  yield takeLatest(actionTypes.GET_SUBSCRIBE_START, getSubscribeSaga)
  yield takeLatest(actionTypes.EXPORT_SUBSCRIBE_FILE_START, exportSubscribeFileSaga)
}
